export default "/images/vendor/flag-icon-css/flags/4x3/tk.svg?54b9e3f941cb3083e2a3f71fe78e0c2d";